	export enum AppointmentRecommendationEnum {
		ContUse = 1,
		Binaural = 2,
		Right = 3,
		Left = 4,
    MedClearance = 5,
    NormalHearing = 6,
    None = 7
	}
